import { createGlobalStyle } from 'styled-components'

export const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html, body {
    width: 100%;
    min-height: 100%;
    overflow-x: hidden;
  }

  html {
    font-family: 'Inter', 'Segoe UI', Roboto, sans-serif;
    color: ${(props) => props.theme.colors.text};
  }

  body {
    background-color: ${(props) => props.theme.colors.background};
    font-size: 14px;
    line-height: 1.5;
    -webkit-font-smoothing: antialiased;
  }

  #root {
    min-height: 100vh;
    width: 100%;
  }

  .ant-modal-root .ant-modal-mask.ant-modal-mask {
    background: rgba(141, 141, 141, 0.2);
  }

  .scrollable {
    scrollbar-width: thin;
    scrollbar-color: ${(props) => props.theme.colors.divider} transparent;

    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
      border-radius: 2px;
    }

    &::-webkit-scrollbar-thumb {
      background: ${(props) => props.theme.colors.divider};
      border-radius: 2px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: ${(props) => props.theme.colors.text};
    }

    &::-webkit-scrollbar-button {
      display: none;
    }
  }
`
